<template>
    <div>
        <b-container>
            <h1 v-t="'experiences'"></h1>

            <b-row>
                <b-col v-for="item in experiences" :key="item.id" lg="4" md="12" class="mb-4">
                    <Experience 
                        :image="item.image"
                        :name="item.name"
                        :description="item.description"
                        :price="item.price"
                        :companies="item.companies" />
                </b-col>
            </b-row>

            <b-button variant="outline-primary" to="experiencias">{{ $t('showMore') }}</b-button>

        </b-container>
    </div>
</template>

<script>
    import Experience from '@/components/Experience.vue';
    import experiencesJSON from '@/data/experiences.json';
    
    export default {
        data() {
            return {
                experiences: experiencesJSON.slice(0, 3)
            }
        },
        components: {
            Experience
        }
    }
</script>

<style lang="scss" scoped>

.row {
    margin: 3.75rem 0 1.875rem;
}

.container {
    margin-bottom: 140px;
}
</style>